import React, { useState } from "react";
import "./brandBook.scss";
import Search from "../../components/search/Search";
import Divider from "../../components/divider/Divider";
import swapIcon from "../../images/brandbook-icons/swap-button-icon.svg";
import arrowIcon from "../../images/menuListIcons/arrow-icon.svg";
import FilterItem from "../../components/filterItem/FilterItem";
import YellowButton from "../../components/buttons/defaultButton/yellowButton/YellowButton";
import WhiteButton from "../../components/buttons/defaultButton/whiteButton/WhiteButton";
import Select from "../../components/select/Select";
import StructureList from "../../components/structureList/StructureList";
import FrameStructureModal from "../../components/modals/frameStructureModal/FrameStructureModal";
import { useGetPageQuery } from "../../redux/services/velmartAPI";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setIsShowIFrame } from "../../redux/slices/statusSlice";

const mainStructureSelectData = [
    { title: "Відділ", id: 1, value: "department" },
    { title: "Обладнання", id: 2, value: "equipment" },
];

const BrandBook = () => {
    const dispatch = useDispatch();
    const [showFrameStructureModal, setShowFrameStructureModal] = useState(false);

    const [departmentIds, setDepartmentIds] = useState([]);
    const [designIds, setDesignIds] = useState([]);
    const [equipmentIds, setEquipmentIds] = useState([]);
    const [selectedStructure, setSelectedStructure] = useState(1);

    const departmentParams =
        departmentIds.length > 0
            ? "&" + departmentIds.map((department) => "department_ids[]=" + department).join("")
            : "";
    const designParams = designIds.length > 0 ? "&" + designIds.map((design) => "design_ids[]=" + design).join("") : "";
    const equipmentParams =
        equipmentIds.length > 0 ? "&" + equipmentIds.map((equipment) => "equipment_ids[]=" + equipment).join("") : "";
    const structureParams =
        "parent=" + mainStructureSelectData.find((structureItem) => structureItem.id === selectedStructure).value;

    const { data: equipments } = useGetPageQuery("equipments?per_page=0" + departmentParams + designParams);
    const { data: designs } = useGetPageQuery("designs?per_page=0" + departmentParams + equipmentParams);
    const { data: departments } = useGetPageQuery("departments?per_page=0" + equipmentParams + designParams);
    const { data: structure, refetch: refetchStructure } = useGetPageQuery("files/structure?" + structureParams);

    const listCheckHandler = (e, list, setList) => {
        if (e.target.checked) {
            setList([...list, +e.target.value]);
        } else if (!e.target.checked) {
            setList([...list.filter((id) => id !== +e.target.value)]);
        }
    };

    useEffect(() => {
        const refetch = async () => {
            await refetchStructure();
        };
        refetch();
    }, []);

    useEffect(() => {
        dispatch(setIsShowIFrame(showFrameStructureModal));
    }, [showFrameStructureModal]);

    return (
        <>
            {equipments && designs && departments && (
                <div className="page-content__container">
                    <FrameStructureModal
                        isOpen={showFrameStructureModal}
                        setIsOpen={setShowFrameStructureModal}
                        structure={structure}
                    />
                    <div className="brandbook">
                        <div className="brandbook__search">
                            <Search placeholder={"Пошук..."} />
                        </div>
                        <Divider text={"Або"} />
                        <div className="brandbook__filters">
                            <div className="brandbook__filters-header">
                                <div className="brandbook__filters-header-left">
                                    <div className="brandbook__filters-header-left-title">Фільтри</div>
                                    {/* <img src={swapIcon} alt="swap" className="brandbook__filters-header-left-button" /> */}
                                </div>
                                {/* <img src={arrowIcon} alt="arrow" className="brandbook__filters-header-right-button" /> */}
                            </div>
                            <div className="brandbook__filters-items">
                                <FilterItem
                                    title={"Відділ:"}
                                    dataList={departments}
                                    checkedList={departmentIds}
                                    listCheckHandler={listCheckHandler}
                                    setCheckedList={setDepartmentIds}
                                />
                                <FilterItem
                                    title={"Елементи оформлення:"}
                                    dataList={designs}
                                    checkedList={designIds}
                                    listCheckHandler={listCheckHandler}
                                    setCheckedList={setDesignIds}
                                />
                                <FilterItem
                                    title={"Обладнання:"}
                                    dataList={equipments}
                                    checkedList={equipmentIds}
                                    listCheckHandler={listCheckHandler}
                                    setCheckedList={setEquipmentIds}
                                />
                            </div>
                            <div className="brandbook__filters-buttons">
                                <YellowButton
                                    text={"Сформировать брендбук"}
                                    onClick={() => setShowFrameStructureModal(true)}
                                />
                                <WhiteButton text={"Брендбук"} onClick={() => setShowFrameStructureModal(true)} />
                            </div>
                        </div>
                        <Divider text={"Або"} />
                        <div className="brandbook__structure">
                            <div className="brandbook__structure-header">
                                <div className="brandbook__structure-header-title">Структура</div>
                                <div className="brandbook__structure-header-select">
                                    <div className="brandbook__structure-header-select-title">Головний:</div>
                                    <Select
                                        width={"190px"}
                                        title={"Відділ"}
                                        listData={mainStructureSelectData}
                                        setValue={setSelectedStructure}
                                        showAllSelect={false}
                                        // selectedTitle="a"
                                    />
                                </div>
                            </div>
                        </div>
                        {structure && <StructureList isDouble={true} listData={structure} isShowIframes={false} />}
                    </div>
                </div>
            )}
        </>
    );
};

export default BrandBook;
